import React, { useState } from 'react';
import { signInWithOAuth } from '../utils/authOAuth';
import Loader from './Loader';

const GoogleIcon = ({ compact }) => (
  <svg className={compact ? 'h-4 w-4 shrink-0' : 'h-5 w-5 shrink-0'} viewBox="0 0 24 24" aria-hidden>
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

const MicrosoftIcon = ({ compact }) => (
  <svg className={compact ? 'h-4 w-4 shrink-0' : 'h-5 w-5 shrink-0'} viewBox="0 0 23 23" aria-hidden>
    <path fill="#f35325" d="M1 1h10v10H1z" />
    <path fill="#81bc06" d="M12 1h10v10H12z" />
    <path fill="#05a6f0" d="M1 12h10v10H1z" />
    <path fill="#ffba08" d="M12 12h10v10H12z" />
  </svg>
);

export default function OAuthButtons({
  variant = 'signin',
  redirectTo,
  className = '',
  signupFlow,
  compact = false,
  theme = 'dark',
}) {
  const [loading, setLoading] = useState(null);
  const isSignup = variant === 'signup';
  const redirect = redirectTo || (typeof window !== 'undefined' ? window.location.origin + window.location.pathname : '');

  const handleOAuth = async (provider) => {
    if (isSignup && typeof window !== 'undefined') {
      if (signupFlow === 'community') sessionStorage.setItem('community_signup_flow', '1');
      if (signupFlow === 'academy') sessionStorage.setItem('academy_signup_flow', '1');
      if (signupFlow === 'venue') sessionStorage.setItem('venue_signup_flow', '1');
    }
    setLoading(provider);
    try {
      const { error } = await signInWithOAuth(provider, redirect);
      if (error) console.error(provider, error);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(null);
    }
  };

  const labelGoogle = compact ? 'Google' : 'Continue with Google';
  const labelMicrosoft = compact ? 'Microsoft' : 'Continue with Microsoft';

  const btnThemes = {
    dark: compact
      ? 'w-full h-9 rounded-lg font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-50 text-[13px] bg-white/[0.08] border border-white/15 text-white hover:bg-white/[0.12] hover:border-white/25'
      : 'w-full h-12 rounded-xl font-medium flex items-center justify-center gap-3 transition-colors disabled:opacity-50 text-sm bg-white/[0.08] border-2 border-white/20 text-white hover:bg-white/[0.14] hover:border-white/30',
    light: compact
      ? 'w-full h-9 rounded-lg font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-50 text-[13px] bg-white border border-slate-200 text-slate-900 hover:bg-slate-50 hover:border-slate-300 shadow-sm'
      : 'w-full h-12 rounded-xl font-medium flex items-center justify-center gap-3 transition-colors disabled:opacity-50 text-sm bg-white border border-slate-200 text-slate-900 hover:bg-slate-50 hover:border-slate-300 shadow-sm',
  };

  const btnBase = btnThemes[theme === 'light' ? 'light' : 'dark'];

  return (
    <div className={`${compact ? 'space-y-2' : 'space-y-3'} ${className}`}>
      <button
        type="button"
        className={btnBase}
        onClick={() => handleOAuth('google')}
        disabled={!!loading}
      >
        {loading === 'google' ? <Loader size={compact ? 16 : 20} /> : <GoogleIcon compact={compact} />}
        <span>{labelGoogle}</span>
      </button>
      <button
        type="button"
        className={btnBase}
        onClick={() => handleOAuth('azure')}
        disabled={!!loading}
      >
        {loading === 'azure' ? <Loader size={compact ? 16 : 20} /> : <MicrosoftIcon compact={compact} />}
        <span>{labelMicrosoft}</span>
      </button>
    </div>
  );
}
